module.exports = __webpack_public_path__ + "img/screen.e27a48a7.png";